import { render, staticRenderFns } from "./SurveyPoint.vue?vue&type=template&id=53e4d6ae&scoped=true"
import script from "./SurveyPoint.vue?vue&type=script&lang=js"
export * from "./SurveyPoint.vue?vue&type=script&lang=js"
import style0 from "./SurveyPoint.vue?vue&type=style&index=0&id=53e4d6ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e4d6ae",
  null
  
)

export default component.exports